module.exports = __webpack_public_path__ + "static/slide-dog-1-7e67583f47fb89d9cb0a70fbe2b655f7.png";